import React from "react";
import { Github, Heart } from "lucide-react";

const Footer: React.FC = () => {
  return (
    <footer className="border-t bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-xl font-bold">InfrAgents.com</span>
            </div>
            <p className="text-muted-foreground max-w-md">
              The community-driven platform for discovering and sharing
              Infrastructure Agents. Build the future of agentic infrastructure.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Platform</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="/" className="hover:text-foreground transition-colors">
                  Discover Agents
                </a>
              </li>
              <li>
                <a
                  href="/submit"
                  className="hover:text-foreground transition-colors"
                >
                  Submit Agent
                </a>
              </li>
              <li>
                <a
                  href="/docs"
                  className="hover:text-foreground transition-colors"
                >
                  Documentation
                </a>
              </li>
              <li>
                <a
                  href="/guidelines"
                  className="hover:text-foreground transition-colors"
                >
                  Guidelines
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Community</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a
                  href="https://github.com/chrisurf/infragents"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-foreground transition-colors inline-flex items-center"
                >
                  <Github className="h-4 w-4 mr-2" />
                  GitHub
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  className="hover:text-foreground transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  className="hover:text-foreground transition-colors"
                >
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} InfrAgents.com. Built with{" "}
            <Heart className="h-4 w-4 inline mx-1 text-red-500" />
            for the infrastructure community.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
